import { jwtDecode } from 'jwt-decode';
import { ClientAuth } from '../sdk';

class ApplicationUser {
    public id: number | null = null;
    public role: string | null = null;
    public token: string | null = null;
    public tabId: string | null = null;
    public rights: Array<string> | null = null;

    constructor(authData: ClientAuth | null) {
        let decodedToken: any = null;
        if (authData?.token) {
            try {
                decodedToken = jwtDecode(authData.token);
            } catch (e) {}
        }

        this.id = decodedToken?.user_id || decodedToken?.manager_id || 1 || null;
        this.role = decodedToken?.role || null;
        this.token = authData?.token || null;
        this.rights = decodedToken?.rights || null;
        this.tabId = authData?.tabId || null;
    }

    get userToken(): string {
        return this.token || '';
    }

    public updateToken(token: string): void {
        this.token = token;
    }

    public hasRight(right: string): boolean {
        if (this.rights) {
            return this.rights.includes(right);
        }
        return false;
    }

    get isEmployee() {
        return this.role === 'employee';
    }

    get isManager() {
        return this.role === 'manager' || this.role === 'superadmin' || this.role === 'admin';
    }

    get isAdmin() {
        return this.role === 'admin' || this.role === 'superadmin';
    }
}

export default ApplicationUser;
